/** How long a press must last before the Zoom link editor opens. */
const ZOOM_PRESS_MS = 600;

const ZOOM_URL_KEY = 'ichat-zoom-url';

const DEFAULT_ZOOM_URL =
  'https://us02web.zoom.us/j/8087358885?pwd=cngwcXVCcW44dDUwYnczdVNXZWMxQT09';

/** Keep an http(s) address as typed. Anything else is empty. */
function zoomUrlOrEmpty(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  try {
    const parsed = new URL(text);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
    return text;
  } catch {
    return '';
  }
}

function readZoomUrl(storage) {
  try {
    const saved = zoomUrlOrEmpty(storage && storage.getItem(ZOOM_URL_KEY));
    return saved || DEFAULT_ZOOM_URL;
  } catch {
    return DEFAULT_ZOOM_URL;
  }
}

/** Blank clears the saved link and restores the default. Invalid text is refused. */
function writeZoomUrl(storage, value) {
  const text = String(value || '').trim();
  if (!text) {
    storage.removeItem(ZOOM_URL_KEY);
    return DEFAULT_ZOOM_URL;
  }
  const url = zoomUrlOrEmpty(text);
  if (!url) return '';
  storage.setItem(ZOOM_URL_KEY, url);
  return url;
}

/**
 * Open the join link in a new tab. A null return from window.open is normal
 * when the browser withholds the new tab's window object, so this does not
 * follow the link in the current tab.
 */
function openZoomMeeting(url, win) {
  const target = zoomUrlOrEmpty(url) || DEFAULT_ZOOM_URL;
  if (!win || typeof win.open !== 'function') return false;
  const child = win.open(target, '_blank', 'noopener,noreferrer');
  if (child) child.opener = null;
  return true;
}

module.exports = {
  ZOOM_PRESS_MS,
  ZOOM_URL_KEY,
  DEFAULT_ZOOM_URL,
  readZoomUrl,
  writeZoomUrl,
  openZoomMeeting,
};
